import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from '../Icon';

const ConfirmationContainer = styled.div`
  padding-bottom: 30px;
  text-align: center;
`;

const mapStateToProps = ({
  language,
  pickupAddon: { email },
  retailerSettings: { branding: { brand_call_to_action: brandCtaColor } = {} } = {},
}) => ({
  email,
  brandCtaColor,
  header: language['returns.pickups_page.email_confirmation.header'],
  emailConfirmation: language['returns.pickups_page.email_confirmation.description'],
});

const Confirmation = ({ email, brandCtaColor, emailConfirmation, header }) => (
  <ConfirmationContainer className="pickup-confirmation">
    <div aria-label="Transaction Success" role="alert" style={{ margin: '1rem auto' }}>
      <Icon.Truck s={{ width: '6rem' }} outlineColor={brandCtaColor} noFill />
    </div>
    <h2 style={{ fontFamily: 'inherit' }} dangerouslySetInnerHTML={{ __html: header }} />
    <div>{`${emailConfirmation}${email}`}</div>
  </ConfirmationContainer>
);

Confirmation.defaultProps = {
  brandCtaColor: '#000000',
};

Confirmation.propTypes = {
  header: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  emailConfirmation: PropTypes.string.isRequired,
  brandCtaColor: PropTypes.string,
};

export default connect(mapStateToProps)(Confirmation);
